"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var apiService_1 = __importDefault(require("@common/services/apiService"));
var clsx_1 = __importDefault(require("clsx"));
var react_use_1 = require("react-use");
var RuleConditions_1 = __importDefault(require("./components/RuleConditions"));
var Button_1 = __importStar(require("@/react-app/common/components/Button"));
var FilterTester_1 = __importDefault(require("./components/FilterTester"));
var BlangEditor_1 = require("@/react-app/common/components/BlangEditor");
var RuleDecision_1 = __importDefault(require("./components/RuleDecision"));
var SwitchBox_1 = __importDefault(require("@/react-app/common/components/SwitchBox"));
var Tooltip_1 = require("@/react-app/common/components/Tooltip");
var Loading_1 = __importDefault(require("@/react-app/common/components/Loading"));
var ruleModeManager_1 = require("./ruleModeManager");
var dictionaries_1 = require("@/react-app/common/services/dictionaries");
function RulePage(_a) {
    var _this = this;
    var headerText = _a.headerText, domain = _a.domain, onCancel = _a.onCancel, buttonText = _a.buttonText, ruleState = _a.ruleState, onSave = _a.onSave, setRuleState = _a.setRuleState;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = __read((0, react_1.useState)(true), 2), isInSimpleMode = _b[0], setIsInSimpleMode = _b[1];
    var _c = __read((0, react_1.useState)(), 2), domainBlangVariables = _c[0], setDomainBlangVariables = _c[1];
    var _d = __read((0, react_1.useState)(true), 2), canShowRuleInSimpleMode = _d[0], setCanShowRuleInSimpleMode = _d[1];
    var _e = __read((0, react_1.useState)(true), 2), canShowRuleInAdvancedMode = _e[0], setCanShowRuleInAdvancedMode = _e[1];
    var _f = __read((0, react_1.useState)(undefined), 2), ruleVariables = _f[0], setRuleVariables = _f[1];
    var data = (0, dictionaries_1.useGetDictionariesQuery)({ domain: domain, kind: 'MIXED,CONFUSABLE' }).data;
    var dictionaries = (data === null || data === void 0 ? void 0 : data.results) ? data.results : [];
    // console.log('ruleVariables', ruleVariables);
    var _g = __read((0, react_1.useState)(false), 2), isLoading = _g[0], setIsLoading = _g[1];
    var _h = __read((0, react_1.useState)(), 2), errorMsg = _h[0], setErrorMsg = _h[1];
    var _j = __read((0, react_1.useState)(false), 2), isRuleExpressionValid = _j[0], setIsRuleExpressionValid = _j[1];
    var _k = __read((0, react_1.useState)(false), 2), isSubmitted = _k[0], setIsSubmitted = _k[1];
    var currentExpression = ruleState.rule;
    // console.log('currentExpression', currentExpression);
    // console.log('ruleState', ruleState);
    // console.log('canShowRuleInAdvancedMode', canShowRuleInAdvancedMode);
    // console.log('canShowRuleInSimpleMode', canShowRuleInSimpleMode);
    var hasBlangEditorError = errorMsg || (!currentExpression && isSubmitted);
    var advancedMode = !isInSimpleMode;
    var isRuleNameValid = ruleState.name && ruleState.name.length >= 3;
    var getBlangVariablesThenEvaluateRuleMode = function () { return __awaiter(_this, void 0, void 0, function () {
        var result, newDomainBlangVariables, emptyRule, canShowInSimpleMode;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, apiService_1.default.getBlangVariables({ domain: domain })];
                case 1:
                    result = _a.sent();
                    newDomainBlangVariables = result.data.map(function (item) { return (__assign(__assign({}, item), { text: item.label })); });
                    setDomainBlangVariables(newDomainBlangVariables);
                    emptyRule = currentExpression === '';
                    if (emptyRule) {
                        setIsInSimpleMode(true);
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, validateBlangRule(domain, currentExpression, newDomainBlangVariables)];
                case 2:
                    canShowInSimpleMode = (_a.sent()) || false;
                    // display simple by default (Initially) if possible
                    // when it's valid or when the rule is empty(adding new rule)
                    setIsInSimpleMode(canShowInSimpleMode);
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getBlangVariablesThenEvaluateRuleMode();
    }, []);
    var evaluateRuleMode = function (validationData, domainBlangVariables, expression) {
        try {
            var canShowSimpleMode = (0, ruleModeManager_1.getCanShowRuleInSimpleMode)(validationData, domainBlangVariables, expression) || false;
            setCanShowRuleInAdvancedMode(expression !== undefined && expression !== null);
            setCanShowRuleInSimpleMode(canShowSimpleMode);
            return canShowSimpleMode;
        }
        catch (error) {
            return false;
        }
    };
    var submit = function () {
        setIsSubmitted(true);
        if (!isRuleExpressionValid ||
            !isRuleNameValid ||
            !ruleState.rule ||
            !ruleState.result ||
            (ruleState.result === 'REFUSE' && !ruleState.decisionId) ||
            (ruleState.result === 'MANUAL' && !ruleState.routingQueue)) {
            return false;
        }
        onSave();
    };
    var updateRuleExpression = function (newExpression) {
        if (!newExpression) {
            // When rule conditions is empty (newExpression === '') NO RULE enable Advanced mode switching
            if (newExpression === '') {
                setCanShowRuleInAdvancedMode(true);
            }
            else {
                setCanShowRuleInAdvancedMode(false);
            }
            setIsRuleExpressionValid(false);
            return;
        }
        setRuleState(__assign(__assign({}, ruleState), { rule: newExpression }));
        validateBlangRule(domain, newExpression, domainBlangVariables);
    };
    var validateBlangRule = function (domain, ruleParam, domainBlangVariablesParam) { return __awaiter(_this, void 0, void 0, function () {
        var validateRuleResult, validationData, canShowInSimpleMode, msg_1, msg, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService_1.default.validateBlangRule({ domain: domain }, ruleParam)];
                case 1:
                    validateRuleResult = _a.sent();
                    validationData = validateRuleResult.data;
                    // result is a boolean to indicate if the rule is valid or not
                    if (validationData.result) {
                        setRuleVariables(validationData.parsedRule);
                        setIsRuleExpressionValid(true);
                        setErrorMsg(undefined);
                        if ((domainBlangVariablesParam === null || domainBlangVariablesParam === void 0 ? void 0 : domainBlangVariablesParam.length) && validationData) {
                            canShowInSimpleMode = evaluateRuleMode(validationData, domainBlangVariablesParam, ruleParam);
                            return [2 /*return*/, canShowInSimpleMode];
                        }
                    }
                    // error msg
                    if (validationData.location && validationData.location.start) {
                        msg_1 = "Line ".concat(validationData.location.start.line, ", column ").concat(validationData.location.start.column, ": ").concat(validationData.message);
                        setErrorMsg(msg_1);
                        setIsRuleExpressionValid(false);
                        return [2 /*return*/];
                    }
                    msg = validationData.message;
                    setErrorMsg(msg);
                    setIsRuleExpressionValid(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Error in validateBlangRule', error_1);
                    return [2 /*return*/, undefined];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onCodeMirrorChange = (0, react_1.useCallback)(function (newRule) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setRuleState(__assign(__assign({}, ruleState), { rule: newRule }));
            return [2 /*return*/];
        });
    }); }, [domainBlangVariables]);
    // debounce validation api to prevent multiple requests
    (0, react_use_1.useDebounce)(function () { return __awaiter(_this, void 0, void 0, function () {
        var canShowInSimpleMode;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!currentExpression) {
                        // when the rule is empty, we can show simple mode
                        setCanShowRuleInSimpleMode(true);
                        setErrorMsg(undefined);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, validateBlangRule(domain, currentExpression, domainBlangVariables)];
                case 1:
                    canShowInSimpleMode = _a.sent();
                    setCanShowRuleInSimpleMode(canShowInSimpleMode !== null && canShowInSimpleMode !== void 0 ? canShowInSimpleMode : false);
                    return [2 /*return*/];
            }
        });
    }); }, 500, [currentExpression]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "rule-editor-header" },
            react_1.default.createElement("h3", null,
                " ",
                headerText),
            react_1.default.createElement("div", { className: "link-to-switch-mode" },
                isInSimpleMode && (react_1.default.createElement("a", { className: (0, clsx_1.default)('eva-link-secondary tooltips', {
                        'disabled-link': !canShowRuleInAdvancedMode,
                    }), onClick: function () { return canShowRuleInAdvancedMode && setIsInSimpleMode(false); }, id: "link-to-advanced-mode", "aria-disabled": !canShowRuleInAdvancedMode },
                    t('AUTOMATION.DECISION_RULES.RULE_BUILDER.BASIC_MODE.ADVANCED_MODE_LINK'),
                    !canShowRuleInAdvancedMode && (react_1.default.createElement("span", null, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.BASIC_MODE.ADVANCED_MODE_LINK_TOOLTIP'))))),
                advancedMode && (react_1.default.createElement("a", { className: (0, clsx_1.default)('eva-link-secondary tooltips', {
                        'disabled-link': !canShowRuleInSimpleMode,
                    }), onClick: function () { return canShowRuleInSimpleMode && setIsInSimpleMode(true); }, id: "link-to-simple-mode", "aria-disabled": !canShowRuleInSimpleMode },
                    t('AUTOMATION.DECISION_RULES.RULE_BUILDER.ADVANCED_MODE.BASIC_MODE_LINK'),
                    !canShowRuleInSimpleMode && (react_1.default.createElement("span", null, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.ADVANCED_MODE.BASIC_MODE_LINK_TOOLTIP'))))))),
        isLoading && react_1.default.createElement(Loading_1.default, null),
        !isLoading && (react_1.default.createElement("form", { name: "ruleCreateForm" },
            react_1.default.createElement("div", { "data-ng-if": "$ctrl.isReadyToShow" },
                react_1.default.createElement("div", { className: "rule-name-description" },
                    react_1.default.createElement("div", { className: (0, clsx_1.default)('rule-name form-group', {
                            // TO DO understand how has-success and has-error are changing the border color
                            'has-error': !isRuleNameValid && isSubmitted,
                            'has-success': isRuleNameValid,
                        }) },
                        react_1.default.createElement("label", { htmlFor: "rule-name" }, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.RULE_NAME_LABEL')),
                        react_1.default.createElement("input", { "data-cy": "input-rule-name", placeholder: t('AUTOMATION.DECISION_RULES.RULE_BUILDER.RULE_NAME_PLACEHOLDER'), id: "rule-name", name: "ruleName", className: "form-control", value: ruleState.name, required: true, minLength: 3, onChange: function (e) { return setRuleState(__assign(__assign({}, ruleState), { name: e.target.value })); } }),
                        !isRuleNameValid && isSubmitted && (react_1.default.createElement("p", { className: "help-block" }, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.MIN_LENGTH_TEXT')))),
                    react_1.default.createElement("div", { className: "rule-description" },
                        react_1.default.createElement("label", { htmlFor: "rule-description" },
                            t('AUTOMATION.DECISION_RULES.RULE_BUILDER.RULE_DESCRIPTION_LABEL'),
                            ' ',
                            t('AUTOMATION.DECISION_RULES.RULE_BUILDER.OPTIONAL_LABEL')),
                        react_1.default.createElement("textarea", { "data-cy": "input-rule-description", id: "rule-description", name: "ruleDescription", placeholder: t('AUTOMATION.DECISION_RULES.RULE_BUILDER.RULE_DESCRIPTION_PLACEHOLDER'), className: "form-control", rows: 1, value: ruleState.description, onChange: function (e) { return setRuleState(__assign(__assign({}, ruleState), { description: e.target.value })); } }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: (0, clsx_1.default)('rule-mode', {
                            'advanced-mode-selected': !isInSimpleMode,
                        }) },
                        react_1.default.createElement("label", null,
                            t('AUTOMATION.DECISION_RULES.RULE_BUILDER.EDITOR_HEADER'),
                            react_1.default.createElement("span", { className: "tooltip-icon more-info-tooltip implioicons-question-mark-filled eva-tooltip-container--center" },
                                react_1.default.createElement(Tooltip_1.Tooltip, { className: "small-tooltip-style" },
                                    react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement("div", null, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.EDITOR_ICON_TOOLTIP')),
                                        react_1.default.createElement("div", { className: "tooltip-link-container" },
                                            react_1.default.createElement("a", { href: "https://help.besedo.com/18062-automation/rule-basic-mode", target: "_blank", rel: "noreferrer" },
                                                react_1.default.createElement("u", null, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.EDITOR_ICON_TOOLTIP_LINK')))))))),
                        isInSimpleMode && domainBlangVariables && (react_1.default.createElement(RuleConditions_1.default, { domain: domain, expression: currentExpression, isSubmitted: isSubmitted, updateRuleExpression: updateRuleExpression, domainBlangVariables: domainBlangVariables, dictionaries: dictionaries })),
                        !isInSimpleMode && (react_1.default.createElement("div", { className: (0, clsx_1.default)('form-group', {
                                'has-error': !currentExpression && isSubmitted,
                            }) },
                            react_1.default.createElement(BlangEditor_1.BlangEditor, { editable: true, value: currentExpression, onChange: onCodeMirrorChange, height: "300px", hasError: !!hasBlangEditorError, dictionaries: dictionaries, enableAutocomplete: true, resizable: true, errorMsg: errorMsg }))),
                        isSubmitted && !isRuleExpressionValid && (react_1.default.createElement("p", { className: "warning-text", id: "rule-mode-error" }, t('AUTOMATION.DECISION_RULES.ERROR.REQUIRED_VALID_RULE_TEXT')))),
                    !isInSimpleMode && (react_1.default.createElement(FilterTester_1.default, { domain: domain, filter: ruleState, isRuleExpressionValid: isRuleExpressionValid, ruleVariables: ruleVariables, currentExpression: currentExpression })),
                    react_1.default.createElement("div", { className: "clearfix" })),
                react_1.default.createElement(RuleDecision_1.default, { rule: ruleState, isSubmitted: isSubmitted, domain: domain, setRule: setRuleState }),
                react_1.default.createElement("label", { className: "status-switch-label" },
                    t('AUTOMATION.DECISION_RULES.RULE_BUILDER.STATUS_LABEL'),
                    react_1.default.createElement("span", { className: "tooltip-icon more-info-tooltip implioicons-question-mark-filled eva-tooltip-container--center" },
                        react_1.default.createElement(Tooltip_1.Tooltip, { className: "small-tooltip-style" }, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.STATUS_TOOLTIP')))),
                react_1.default.createElement(SwitchBox_1.default, { checked: ruleState.enabled, onToggle: function (checked) { return setRuleState(__assign(__assign({}, ruleState), { enabled: checked })); } }),
                react_1.default.createElement("div", { className: "decision-buttons" },
                    react_1.default.createElement(Button_1.SecondaryButton, { text: t('AUTOMATION.DECISION_RULES.BTN.CANCEL_PASCAL'), onClick: onCancel }),
                    react_1.default.createElement(Button_1.default, { text: buttonText, onClick: function () { return submit(); } })))))));
}
exports.default = RulePage;
